// =============================================================================
// Child theme — front-end behaviour entry point.
//
// Add project modules under ./modules/ and import + boot them here, e.g.:
//   import initNav from "./modules/nav.js";
//
// Everything a module touches should already be rendered and styled by PHP and
// SCSS, so the page stays usable before this bundle runs.
// =============================================================================

import initSearchSuggest from "./modules/search-suggest.js";
import initQtyStepper from "./modules/qty-stepper.js";
import initCartKoreanNames from "./modules/cart-korean-name.js";
import initNotranslateNames from "./modules/notranslate-names.js";

function boot() {
	initSearchSuggest();
	initQtyStepper();
	initCartKoreanNames();
	initNotranslateNames();
}

// The bundle is a deferred module, so the document is normally parsed by now.
// The readyState check covers the case where it is not.
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
